import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/ageVerificationApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import WhiskyTemplateWidget from "../../../../components/Apps/AgeVerification/Template/WhiskyTemplateWidget";
import DefaultTemplateWidget from "../../../../components/Apps/AgeVerification/Template/DefaultTemplateWidget";
import WineTemplateWidget from "../../../../components/Apps/AgeVerification/Template/WineTemplateWidget";
import MarijuanaTemplateWidget from "../../../../components/Apps/AgeVerification/Template/MarijuanaTemplateWidget";
import BeerTemplateWidget from "../../../../components/Apps/AgeVerification/Template/BeerTemplateWidget";
import Vaping1TemplateWidget from "../../../../components/Apps/AgeVerification/Template/Vaping1TemplateWidget";

//Import Tabs
import SettingTab from "../../../../components/Apps/AgeVerification/SettingTab";
import ContentTab from "../../../../components/Apps/AgeVerification/ContentTab";
import AppearanceTab from "../../../../components/Apps/AgeVerification/AppearanceTab";

export default function CreateAgeVerification() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Settings");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Whisky_Temp");
    const [selectedLayout, setSelectedLayout] = useState("whisky_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("whisky.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Age Verification");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [ageVerificationTabData, setAgeVerificationTabData] = useState({
        is_website_frontend: "",  
        minimum_age: 18,  
        verification_method: "",  
        date_format: "MM/DD/YYYY",  
        remember_visitor_days: 20,  
        action_type: "Show_Message",  
        action_message: "",  
        action_redirect_url: "",  
        display_on_pages: "Display_All_Pages",  
        hide_on_pages: "None",  
        logo: "",  
        message: "",  
        submit_button_text: "Enter",  
        yes_button_text: "Yes",  
        no_button_text: "No",  
        additional_info: "",  
        caption: "", 
        overlay_background_color: "", 
        popup_background_color: "",  
        text_color: "", 
        submit_button_color: "", 
        yes_button_color: "", 
        no_button_color: "", 
        font_type: "Default", 
        message_font: "", 
        text_font: "", 
        additional_text_font: "", 
        text_align: "Center", 
        custom_css: "",    
        custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let verification_method = "";
            let action_message = "";
            let message = "";
            let caption = "";
            let additional_info = "";
            let yes_button_text = "";
            let no_button_text = "";
            let overlay_background_color = "";
            let popup_background_color = "";
            let text_color = "";
            let submit_button_color = "";
            let yes_button_color = "";
            let no_button_color = "";
            let message_font = "";
            let text_font = "";
            let additional_text_font = "";
        
            switch (activeTemplateSection) {
                case "Whisky_Temp":
                    verification_method = "Year of Birth";
                    action_message = "You are not old enough to view this content";
                    message = "Hello there, Care to show us some ID?";
                    caption = "Please, enter your date of birth:";
                    additional_info = "By entering this website, you certify that you are of legal smoking age in the state in which you reside.";
                    yes_button_text = "Yes";
                    no_button_text = "No";
                    overlay_background_color = "rgba(0, 0, 0, 0.49)";
                    popup_background_color = "#fff";
                    text_color = "#000";
                    submit_button_color = "#000";
                    yes_button_color = "#FE8100";
                    no_button_color = "#000";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                case "Default_Temp":
                    verification_method = "Yes/No Buttons";
                    action_message = "You are not old enough to view this content";
                    message = "Welcome to our website";
                    caption = "Please, verify your age to enter.";
                    additional_info = "By entering this site you are agreeing to the Terms of Use and Privacy Policy.";
                    yes_button_text = "I am over 18";
                    no_button_text = "I am under 18";
                    overlay_background_color = "#0000007d";
                    popup_background_color = "rgb(255, 255, 255)";
                    text_color = "#212529";
                    submit_button_color = "#fbac00";
                    yes_button_color = "#fbac00";
                    no_button_color = "#000";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                case "Wine_Temp":
                    verification_method = "Year of Birth";
                    action_message = "You are not old enough to view this content";
                    message = "Hello there, Care to show us some ID?";
                    caption = "Please, enter your birthdate:";
                    additional_info = "By entering this site you are agreeing to the Terms of Use and Privacy Policy.";
                    yes_button_text = "Yes";
                    no_button_text = "No";
                    overlay_background_color = "#0000005c";
                    popup_background_color = "rgba(0, 0, 0, 0.36)";
                    text_color = "#fff";
                    submit_button_color = "#000";
                    yes_button_color = "#FE8100";
                    no_button_color = "#000";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                case "Marijuana_Temp":
                    verification_method = "Yes/No Buttons";
                    action_message = "You are not old enough to view this content";
                    message = "You must be over 21 years old to visit this site";
                    caption = "Please, verify your age.";
                    additional_info = "";
                    yes_button_text = "Yes, I am over 21 - ENTER";
                    no_button_text = "No, I am under 21 - LEAVE";
                    overlay_background_color = "#0000005c";
                    popup_background_color = "#fff";
                    text_color = "#fff";
                    submit_button_color = "#000";
                    yes_button_color = "#0000005c";
                    no_button_color = "#000";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                case "Beer_Temp":
                    verification_method = "Yes/No Buttons";
                    action_message = "You are not old enough to view this content";
                    message = "Care for a mug of ale? Confirm that you are over 21 years old and come join us!";
                    caption = "";
                    additional_info = "By entering this site you are agreeing to the Terms of Use and Privacy Policy.";
                    yes_button_text = "I am over 21 Years";
                    no_button_text = "I am under 21 Years";
                    overlay_background_color = "#0000005c";
                    popup_background_color = "";
                    text_color = "#fff";
                    submit_button_color = "#FE8100";
                    yes_button_color = "#FE8100";
                    no_button_color = "#000";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                case "Vaping_1_Temp":
                    verification_method = "Yes/No Buttons";
                    action_message = "You are not old enough to view this content";
                    message = "Are you of legal smoking age?";
                    caption = "";
                    additional_info = "By entering this website, you certify that you are of legal smoking age in the state in which you reside.";
                    yes_button_text = "Yes";
                    no_button_text = "No";
                    overlay_background_color = "#0000005c";
                    popup_background_color = "linear-gradient(131deg, #FE8100 -4.12%, #F5FF00 100%)";
                    text_color = "#000";
                    submit_button_color = "#000";
                    yes_button_color = "#000";
                    no_button_color = "#0000005c";
                    message_font = "28px";
                    text_font = "17px";
                    additional_text_font = "17px";
                    break;
                default:
                    verification_method = "Year of Birth";
                    action_message = "";
                    message = "";
                    caption = "";
                    additional_info = "";
                    yes_button_text = "";
                    no_button_text = "";
                    overlay_background_color = "";
                    popup_background_color = "";
                    text_color = "";
                    submit_button_color = "";
                    yes_button_color = "";
                    no_button_color = "";
                    message_font = "";
                    text_font = "";
                    additional_text_font = "";
            }
        
            // Update setAgeVerificationTabData state with the data
            setAgeVerificationTabData((prevData) => ({
                ...prevData,
                verification_method: verification_method,
                action_message: action_message,
                message: message,
                caption: caption,
                additional_info: additional_info,
                yes_button_text: yes_button_text,
                no_button_text: no_button_text,
                overlay_background_color: overlay_background_color,
                popup_background_color: popup_background_color,
                text_color: text_color,
                submit_button_color: submit_button_color,
                yes_button_color: yes_button_color,
                no_button_color: no_button_color,
                message_font: message_font,
                text_font: text_font,
                additional_text_font: additional_text_font,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateAgeVerificationTabData = (key, value) => {
        setAgeVerificationTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Settings", icon: "setting.png", label: "Settings" },
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Appearance", icon: "appearance.png", label: "Appearance" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(ageVerificationTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Age_Verification",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/age-verification');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Age Verification" app_type="Age_Verification" app_slug="age-verification"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Whisky_Temp" data-layout_type="whisky_layout" data-template_image="whisky.png" checked={activeTemplateSection === "Whisky_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/whisky.png`} alt="whisky" />
                                    </div> 
                                    <div className="content_sub">Whisky</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Default_Temp" data-layout_type="default_layout" data-template_image="default.png" checked={activeTemplateSection === "Default_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/default.png`} alt="default" />
                                    </div>
                                    <div className="content_sub">Default</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Wine_Temp" data-layout_type="wine_layout" data-template_image="wine.png" checked={activeTemplateSection === "Wine_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/wine.png`} alt="wine" />
                                    </div>
                                    <div className="content_sub">Wine</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Marijuana_Temp" data-layout_type="marijuana_layout" data-template_image="marijuana.png" checked={activeTemplateSection === "Marijuana_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/marijuana.png`} alt="marijuana" />
                                    </div>
                                    <div className="content_sub">Marijuana</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Beer_Temp" data-layout_type="beer_layout"  data-template_image="beer.png" checked={activeTemplateSection === "Beer_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/beer.png`} alt="beer" />
                                    </div>
                                    <div className="content_sub">Beer</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Vaping_1_Temp" data-layout_type="vaping_1_layout" data-template_image="vaping_1.png" checked={activeTemplateSection === "Vaping_1_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/age-verification/templates/vaping_1.png`} alt="vaping_1" />
                                    </div>
                                    <div className="content_sub">Vaping 1</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/age-verification/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Settings" && (
                              <SettingTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData} />
                            )}
                            {activeSection === "Content" && (
                              <ContentTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData} />
                            )}
                            {activeSection === "Appearance" && (
                              <AppearanceTab updateAgeVerificationTabData={updateAgeVerificationTabData} ageVerificationTabData={ageVerificationTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/age-verification"><i className="fa fa-angle-left" aria-hidden="true"></i></Link> Back</h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/age-verification/age-verification.svg`} alt="age-verification"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/age-verification/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/age-verification" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Age Verification <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Whisky_Temp" && (
                      <WhiskyTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Default_Temp" && (
                      <DefaultTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Wine_Temp" && (
                      <WineTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Marijuana_Temp" && (
                      <MarijuanaTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Beer_Temp" && (
                      <BeerTemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}

                    {activeTemplateSection === "Vaping_1_Temp" && (
                      <Vaping1TemplateWidget ageVerificationTabData={ageVerificationTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 